import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

const isNative = Capacitor.isNativePlatform();

export const tokenStorage = {
  async setItem(key, value) {
    if (isNative) {
      await SecureStoragePlugin.set({ key, value });
    } else {
      localStorage.setItem(key, value);
    }
  },
  async getItem(key) {
    if (isNative) {
      try {
        const { value } = await SecureStoragePlugin.get({ key });
        return value;
      } catch (e) {
        return null;
      }
    } else {
      return localStorage.getItem(key);
    }
  },
  async removeItem(key) {
    if (isNative) {
      try {
        await SecureStoragePlugin.remove({ key });
      } catch (e) {}
    } else {
      localStorage.removeItem(key);
    }
  },
  async clear() {
    if (isNative) {
      try {
        await SecureStoragePlugin.remove({ key: 'accessToken' });
        await SecureStoragePlugin.remove({ key: 'refreshToken' });
        await SecureStoragePlugin.remove({ key: 'user' });
      } catch (e) {}
    } else {
      localStorage.clear();
    }
  }
};
